import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../config/Config'
import Footer from '../../common/footer/Footer'
import Header from '../../common/header/Header'
import { get_Page_Seo } from '../../../api/global/Global'
import Loader from '../../../loader/Loader'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';
import { fetchHomeData } from '../../../redux/actions/homedataAction'
import { useDispatch, useSelector } from 'react-redux'

const All_Letest_Post = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { homeData, isLoading } = useSelector(
        (state) => state?.homedata || {}
    );
    const [is_loading, set_Is_Loading] = useState(isLoading || false)
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSeo, set_Page_Seo] = useState({})

    const productsPerPage = 12;
    const totalPages = Math.ceil(homeData?.blog?.length / productsPerPage) || 1;
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = homeData?.blog?.slice(startIndex, startIndex + productsPerPage) || [];

    const getPaginationItems = () => {
        const items = [];
        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                items.push(i);
            }
        } else {
            if (currentPage <= 3) {
                items.push(1, 2, 3, 4, '...', totalPages);
            } else if (currentPage >= totalPages - 2) {
                items.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            } else {
                items.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
            }
        }
        return items;
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    useEffect(() => {
        dispatch(fetchHomeData());
    }, [dispatch]);

    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Blogs")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }
        Get_Page_Seo()
    }, [])

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {/*  */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{pageSeo?.meta_title}</title>
                            <meta name="description" content={pageSeo?.meta_description} />
                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}blogs`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}blogs`} />
                        </Helmet>
                        {/*  */}
                        <Header />
                        <section className='banner-section'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-auto object-cover' />
                            </div>
                        </section>
                        <section className="gi-blog-section py-[40px] max-[767px]:py-[30px] wow fadeInUp">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[770px] min-[576px]:max-w-[560px]">
                                <div className="w-full flex flex-wrap mb-[-24px]">
                                    <div className="section-title w-full mb-[20px] pb-[20px] flex justify-between pb-[20px] z-[5] max-[575px]:flex-col px-[12px]">
                                        <div className="section-detail">
                                            <h1
                                                className="gi-title mb-[0] text-[25px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1] font-Poppins max-[991px]:text-[24px] max-[767px]:text-[22px] max-[575px]:text-[20px]">
                                                Latest <span className="text-[#9F2225]">Posts</span></h1>
                                            <p className="max-w-[400px] mt-[10px] text-[14px] text-[#777] leading-[18px]">Explore our award
                                                winning blogs</p>
                                        </div>
                                    </div>
                                    <div className="grid gap-6 grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-[12px]">
                                        {
                                            currentProduct?.map((letest_blog_result) => {
                                                return (
                                                    <div onClick={() => localStorage.setItem("letest_blog_result_id", letest_blog_result?.id)}>
                                                        <Link to={`/blog/${letest_blog_result?.slug}`}>
                                                            <div className="gi-blog-item">
                                                                <div
                                                                    className="blog-info transition-all duration-[0.3s] ease-in-out w-full mb-[24px] hover:shadow-lg shadow-custome rounded-[5px]">
                                                                    <figure className="blog-img w-full h-auto m-[0] relative overflow-hidden rounded-[5px]">
                                                                        <img src={`${IMG_BASE_URL}${letest_blog_result?.image}`} alt={letest_blog_result?.alt_image_title}
                                                                            className="transition-all duration-[0.3s] ease-in-out rounded-[5px] h-56 w-96 object-fill" />
                                                                    </figure>
                                                                    <div className="detail p-3 w-full m-[0]">

                                                                        <h2 className=" p-[0] font-Poppins text-[#4b5966] text-[17px] font-medium leading-[22px] line-clamp-1">{letest_blog_result?.title}</h2>
                                                                        <label className=" text-[#999] hover:text-[#5caf90] inline-block text-[13px]">Author - {letest_blog_result?.author_name}</label>
                                                                        <div className="more-info mt-[8px]">
                                                                            <span className="transition-all duration-[0.3s] ease-in-out text-[#DE9553] text-[13px] flex items-center hover:text-[#9F2225]">Read
                                                                                More<i className="fi-rr-angle-double-small-right transition-all duration-[0.3s] ease-in-out ml-[5px] text-[#DE9553] text-[13px] flex"></i></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <!-- Pagination Start --> */}
                                    <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col w-full">
                                        <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, homeData?.blog?.length)} of {homeData?.blog?.length} Products</span>
                                        <ul className="gi-pro-pagination-inner flex gap-1">
                                            {currentPage > 1 && (
                                                <li>
                                                    <button
                                                        onClick={handlePrev}
                                                        className="next w-auto text-[#fff] bg-[#5caf90] bg-red-500 text-[14px] px-2 rounded"
                                                    >
                                                        Prev
                                                    </button>
                                                </li>
                                            )}
                                            {getPaginationItems().map((page, index) => {
                                                if (page === '...') {
                                                    return (
                                                        <li key={`ellipsis-${index}`} className="inline-block float-left">
                                                            <span className="transition-all duration-[0.3s] ease-in-out text-[#777] text-[14px]">
                                                                ...
                                                            </span>
                                                        </li>
                                                    );
                                                }
                                                return (
                                                    <li key={page} className="inline-block float-left">
                                                        <button
                                                            onClick={() => handlePageChange(page)}
                                                            className={`transition-all duration-[0.3s] ease-in-out font-light 
                                                                text-[#777] bg-[#eee] px-2
                                                                text-[14px] rounded
                                                                ${currentPage === page ? 'active bg-red-500 text-white' : 'bg-gray-300 text-black'}`}
                                                        >
                                                            {page}
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                            {currentPage < totalPages && (
                                                <li>
                                                    <button
                                                        onClick={handleNext}
                                                        className="next w-auto text-[#fff] px-2 bg-[#5caf90] text-[14px] rounded"
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                    <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </>
                )
            }
            {/*  */}
        </div>
    )
}

export default All_Letest_Post